export enum MutationKey {
  "ApproveDraft" = "ApproveDraft",
  "RejectDraft" = "RejectDraft",
  "SaveGrowthSection" = "SaveGrowthSection",
  "SaveLifeCycleSection" = "SaveLifeCycleSection",
  "SaveWoodDensitySection" = "SaveWoodDensitySection",
  "SaveBiomassAllocationSection" = "SaveBiomassAllocationSection",
  "SaveBiodiversity" = "SaveBiodiversity",
  "SaveGrowthConditionsSection" = "SaveGrowthConditionsSection",
  "SaveRootsSection" = "SaveRootsSection",
  "SaveConstraintsSection" = "SaveConstraintsSection",
  "SaveCostsSection" = "SaveCostsSection",
  "SaveLabourSection" = "SaveLabourSection",
  "CreatePlant" = "CreatePlant",
  "CopyCafs" = "CopyCafs",
  "MovePlant" = "MovePlant",
  "DeletePlant" = "DeletePlant",
  "UploadDataset" = "UploadDataset",
  "UploadJson" = "UploadJson",
  "UpdatePlantDetails" = "UpdatePlantDetails",
  "UpdateInputDetails" = "UpdatePlantDetails",
  "UpdatePlantProduct" = "UpdatePlantProduct",
  "UpdatePlantGuest" = "UpdatePlantGuest",
  "DeletePlantProduct" = "DeletePlantProduct",
  "DeletePlantGuest" = "DeletePlantGuest",
  "CreatePlantProduct" = "CreatePlantProduct",
  "CreateCafsGuest" = "CreateCafsGuest",
  "CreatePlantRtp" = "CreatePlantRtp",
  "UpdatePlantRtp" = "UpdatePlantRtp",
  "UpdateDataset" = "UpdateDataset",
  "DeletePlantRtp" = "DeletePlantRtp",
  "CreateGuestRtp" = "CreateGuestRtp",
  "DatasetAssign" = "DatasetAssign",
  "DatasetUnassign" = "DatasetUnassign",
  "RegionAssign" = "RegionAssign",
  "RegionUnassign" = "RegionUnassign",
  "Login" = "Login",
  "Logout" = "Logout",
  "DefinitionUpdate" = "DefinitionUpdate",
  "InputCostUpdate" = "InputCostUddate",
  "InputLabourUpdate" = "InputlabourUddate",
  "DeleteProduct" = "DeleteProduct",
  "CreateReference" = "CreateReference",
  "UpdateReference" = "UpdateReference",
  "UpdatePrice" = "UpdatePrice",
  "DeletePrice" = "DeletePrice",
  "ExportPrices" = "ExportPrices",
  "Tooltips" = "tooltips",
  "ExportCafs" = "ExportCafs",
  "ExportCalibrations" = "ExportCalibrations",
  "UploadCalibration" = "UploadCalibration",
  "DeleteCalibration" = "DeleteCalibration",
  "FetchFile" = "FetchFile",
  "DownloadJson" = "DownloadJson",
  "ReferencesTo" = "ReferencesTo",
  "AssignReferencesTo" = "AssignReferencesTo",
  "UnassignReferencesTo" = "UnassignReferencesTo",
  "ExportReferencesTo" = "ExportReferencesTo",
  "SyncZotero" = "SyncZotero",
}
